import React, { FC } from 'react';

import hotelspotMark from '../../../../../assets/images/short-hs-logo.svg?url';
import { useAdGeneratorSettings } from '../../../../../queries';
import { AD_COMPONENTS, toComponentPalette } from '../../../config/components';
import { useAdsGeneratorStore } from '../../../model/store';
import { PanelSection } from '../../common';
import { OptionCard, OptionGrid } from '../Editor.styled';

/** Pełne logo Hotelspota leży w `public/`, więc podajemy je ścieżką. */
const HOTELSPOT_WORDMARK = '/logo-hotelspot.svg';

/**
 * Gotowe elementy kreacji. Każdy wstawia kilka warstw naraz i jest liczony
 * z wymiarów bieżącej planszy oraz z kolorów marki z ustawień, więc pasuje
 * do formatu i do identyfikacji wizualnej bez ręcznego poprawiania.
 */
export const ElementsPanel: FC = () => {
  const scene = useAdsGeneratorStore((state) => state.scene);
  const addElements = useAdsGeneratorStore((state) => state.addElements);
  const { brandColors, fonts, logoUrl } = useAdGeneratorSettings();

  if (!scene) return null;

  const palette = toComponentPalette(brandColors);

  return (
    <PanelSection title="Elementy">
      <p className="text-xs text-gray-500 leading-relaxed">
        Element dokłada się do planszy, nie zastępuje jej. Po wstawieniu każdą warstwę poprawisz osobno.
      </p>
      <OptionGrid>
        {AD_COMPONENTS.map((component) => {
          const Icon = component.icon;
          return (
            <OptionCard
              key={component.id}
              type="button"
              title={component.description}
              onClick={() => addElements(component.build({
                scene,
                palette,
                fonts,
                // Własne logo z ustawień zastępuje oba warianty: kto wgrywa
                // swoją markę, nie chce widzieć na planszy znaku Hotelspota.
                logoUrl: logoUrl || hotelspotMark,
                wordmarkUrl: logoUrl || HOTELSPOT_WORDMARK,
              }))}
            >
              <Icon size={18} />
              {component.label}
            </OptionCard>
          );
        })}
      </OptionGrid>
    </PanelSection>
  );
};
